<template>
  <Dropdown v-model="selectedItem" :options="dropdownItems" optionLabel="text" placeholder="Select a Space"
            class="w-full md:w-14rem">
    <template #value="slotProps">
      <div v-if="slotProps.value" class="flex align-items-center">
        <div>{{ slotProps.value.text }}</div>
      </div>
      <span v-else>
        {{ slotProps.placeholder }}
      </span>
    </template>
    <template #option="slotProps">
      <div class="flex align-items-center">
        <div>{{ slotProps.option.text }}</div>
      </div>
    </template>
  </Dropdown>
</template>
<script setup>
import {ref, onMounted, watch, defineProps, defineEmits, computed} from 'vue';
import {useMainStore, useSlidesStore} from "@/store/index.ts";
import {storeToRefs} from "pinia";

const selectedItem = ref({
  id: 1,
  text: '',
  value: '',
  href: ''
});
const dropdownItems = ref([]);

const props = defineProps({});
const emit = defineEmits(['space-change']);

const slidesStore = useSlidesStore()
const mainStore = useMainStore()
const {slideLibraryActive } = storeToRefs(mainStore)
const { valueModelId } = storeToRefs(slidesStore)

const computedRoutePath = computed(() => {

  return slideLibraryActive.value ? `?vmId=null` : `?vmId=${valueModelId.value}`;

});

watch(slideLibraryActive,  async () => {
  const json = await getSpaces()
  dropdownItems.value = json;
  selectedItem.value = json.find(item => item.value === 'main');
})

const getSpaces = async () => {
  const url = `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/get-spaces${computedRoutePath.value}`;

  const response = await fetch(url, { method: 'GET' });
  return await response.json();
}

onMounted(async () => {
  const json = await getSpaces()
  dropdownItems.value = json;
  selectedItem.value = json.find(item => item.value === 'main');
});

watch(selectedItem.value, (newValue) => {
  emit('space-change', newValue.value);
});
</script>
<style scoped>
  :deep(ul) {
    margin-bottom: 0;
    padding-left: 0;
  }
</style>
